"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var StyledColumn = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  flex-shrink: 0;\n  flex-grow: ", ";\n  flex-basis: ", ";\n  width: ", ";\n  max-width: ", ";\n  margin-left: ", ";\n  justify-content: ", ";\n  align-items: ", ";\n  > div {\n    display: flex;\n    flex: 1 0 auto;\n    flex-direction: column;\n  }\n  @media (", ") {\n    flex-basis: ", ";\n    width: ", ";\n    max-width: ", ";\n    margin-left: 0;\n    margin-left: ", ";\n  }\n  @media (", ") {\n    flex-basis: ", ";\n    width: ", ";\n    max-width: ", ";\n    margin-left: 0;\n    margin-left: ", ";\n  }\n  @media (", ") {\n    flex-basis: ", ";\n    width: ", ";\n    max-width: ", ";\n    margin-left: ", ";\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  flex-shrink: 0;\n  flex-grow: ", ";\n  flex-basis: ", ";\n  width: ", ";\n  max-width: ", ";\n  margin-left: ", ";\n  justify-content: ", ";\n  align-items: ", ";\n  > div {\n    display: flex;\n    flex: 1 0 auto;\n    flex-direction: column;\n  }\n  @media (", ") {\n    flex-basis: ", ";\n    width: ", ";\n    max-width: ", ";\n    margin-left: 0;\n    margin-left: ", ";\n  }\n  @media (", ") {\n    flex-basis: ", ";\n    width: ", ";\n    max-width: ", ";\n    margin-left: 0;\n    margin-left: ", ";\n  }\n  @media (", ") {\n    flex-basis: ", ";\n    width: ", ";\n    max-width: ", ";\n    margin-left: ", ";\n  }\n"])), function (_a) {
    var flexGrow = _a.flexGrow;
    return flexGrow;
}, function (_a) {
    var theme = _a.theme, xs = _a.xs;
    return (Number(xs) / theme.columns) * 100 + "%";
}, function (_a) {
    var theme = _a.theme, xs = _a.xs;
    return (Number(xs) / theme.columns) * 100 + "%";
}, function (_a) {
    var theme = _a.theme, xs = _a.xs;
    return (Number(xs) / theme.columns) * 100 + "%";
}, function (_a) {
    var theme = _a.theme, xsOffset = _a.xsOffset;
    return xsOffset ? (Number(xsOffset) / theme.columns) * 100 + "%" : '0';
}, function (_a) {
    var justifyContent = _a.justifyContent;
    return justifyContent || 'flex-start';
}, function (_a) {
    var alignItems = _a.alignItems;
    return alignItems || 'stretch';
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.sm;
}, function (_a) {
    var theme = _a.theme, sm = _a.sm;
    return (Number(sm) / theme.columns) * 100 + "%";
}, function (_a) {
    var theme = _a.theme, sm = _a.sm;
    return (Number(sm) / theme.columns) * 100 + "%";
}, function (_a) {
    var theme = _a.theme, sm = _a.sm;
    return (Number(sm) / theme.columns) * 100 + "%";
}, function (_a) {
    var theme = _a.theme, smOffset = _a.smOffset;
    return smOffset ? (Number(smOffset) / theme.columns) * 100 + "%" : '0';
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.md;
}, function (_a) {
    var theme = _a.theme, md = _a.md;
    return (Number(md) / theme.columns) * 100 + "%";
}, function (_a) {
    var theme = _a.theme, md = _a.md;
    return (Number(md) / theme.columns) * 100 + "%";
}, function (_a) {
    var theme = _a.theme, md = _a.md;
    return (Number(md) / theme.columns) * 100 + "%";
}, function (_a) {
    var theme = _a.theme, mdOffset = _a.mdOffset;
    return mdOffset ? (Number(mdOffset) / theme.columns) * 100 + "%" : '0';
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.lg;
}, function (_a) {
    var theme = _a.theme, lg = _a.lg;
    return (Number(lg) / theme.columns) * 100 + "%";
}, function (_a) {
    var theme = _a.theme, lg = _a.lg;
    return (Number(lg) / theme.columns) * 100 + "%";
}, function (_a) {
    var theme = _a.theme, lg = _a.lg;
    return (Number(lg) / theme.columns) * 100 + "%";
}, function (_a) {
    var theme = _a.theme, lgOffset = _a.lgOffset;
    return lgOffset ? (Number(lgOffset) / theme.columns) * 100 + "%" : '0';
});
var ColumnContent = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  border-style: solid;\n  border-color: ", ";\n  border-width: ", ";\n  max-width: 100%;\n"], ["\n  border-style: solid;\n  border-color: ", ";\n  border-width: ", ";\n  max-width: 100%;\n"])), function (_a) {
    var theme = _a.theme, borderColor = _a.borderColor;
    return borderColor || theme.colors.borderColor;
}, function (_a) {
    var borderLeft = _a.borderLeft, borderRight = _a.borderRight, borderBottom = _a.borderBottom, borderTop = _a.borderTop;
    return (borderTop ? '1px' : '0') + " \n       " + (borderRight ? '1px' : '0') + " \n       " + (borderBottom ? '1px' : '0') + " \n       " + (borderLeft ? '1px' : '0');
});
var Column = function (_a) {
    var _b = _a.xs, xs = _b === void 0 ? '12' : _b, _c = _a.sm, sm = _c === void 0 ? '12' : _c, _d = _a.md, md = _d === void 0 ? '12' : _d, _e = _a.lg, lg = _e === void 0 ? '12' : _e, xsOffset = _a.xsOffset, smOffset = _a.smOffset, mdOffset = _a.mdOffset, lgOffset = _a.lgOffset, children = _a.children, _f = _a.justifyContent, justifyContent = _f === void 0 ? 'flex-start' : _f, _g = _a.alignItems, alignItems = _g === void 0 ? 'stretch' : _g, _h = _a.borderRight, borderRight = _h === void 0 ? false : _h, _j = _a.borderTop, borderTop = _j === void 0 ? false : _j, _k = _a.borderLeft, borderLeft = _k === void 0 ? false : _k, _l = _a.borderBottom, borderBottom = _l === void 0 ? false : _l, borderColor = _a.borderColor, flexGrow = _a.flexGrow, rest = __rest(_a, ["xs", "sm", "md", "lg", "xsOffset", "smOffset", "mdOffset", "lgOffset", "children", "justifyContent", "alignItems", "borderRight", "borderTop", "borderLeft", "borderBottom", "borderColor", "flexGrow"]);
    return (react_1.default.createElement(StyledColumn, { xsOffset: xsOffset, smOffset: smOffset, mdOffset: mdOffset, lgOffset: lgOffset, xs: xs, sm: sm, md: md, lg: lg, justifyContent: justifyContent, alignItems: alignItems, flexGrow: flexGrow || '1' },
        react_1.default.createElement(ColumnContent, __assign({ borderRight: borderRight, borderTop: borderTop, borderLeft: borderLeft, borderBottom: borderBottom, borderColor: borderColor }, rest), children)));
};
exports.default = Column;
var templateObject_1, templateObject_2;
